import React from 'react'
import './credentials.css'
import {BsPatchCheckFill} from 'react-icons/bs'
import {FiServer} from 'react-icons/fi'

const Credentials = () => {
  return (
    <section id='credentials'>
      <h5>Verified and practiced</h5>
      <h2>Credentials &amp; Lab</h2>

      <div className='container credentials_container'>
        <article className='credential_card credential_card--featured'>
          <BsPatchCheckFill className='credential_icon' />
          <p className='credential_kicker'>Certification</p>
          <h3>CompTIA Security+</h3>
          <p className='credential_meta'>Earned 2026</p>
          <p>
            Foundational coverage of threats, architecture, operations, and incident response —
            the baseline I use every day cleaning and analyzing web malware.
          </p>
        </article>

        <article className='credential_card'>
          <FiServer className='credential_icon' />
          <p className='credential_kicker'>Homelab</p>
          <h3>Linux home environment</h3>
          <p className='credential_meta'>Self-hosted, always on</p>
          <ul>
            <li>Linux host with file monitoring for unexpected changes</li>
            <li>Pi-hole for DNS-level filtering on the home network</li>
            <li>Plex and game servers for service uptime and access control practice</li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Credentials
